import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  flex 
  items-center 
  px-3 
  py-2 
  space-x-4 
  bg-white 
  rounded-md
`);

export const inputStyle = ctl(`
  w-full 
  text-black 
  placeholder:text-silver-sand
  focus:outline-none
`);
